import type { ReactElement } from 'react';
import { GameErrorGeoBlocked } from '@/modules/game/GameError/components/GameErrorGeoBlocked';
import { GameErrorNotAuth } from '@/modules/game/GameError/components/GameErrorNotAuth';
import { GameErrorNotAvailCurrency } from '@/modules/game/GameError/components/GameErrorNotAvailCurrency';
import { GameErrorNotFound } from '@/modules/game/GameError/components/GameErrorNotFound';
import type { GameErrorT } from '@/modules/game/GameError/types';
import { GameErrorType } from '@/modules/game/types';

type TGameErrorRenderers = {
  [K in GameErrorType]: (
    error: Extract<GameErrorT, { type: K }>
  ) => ReactElement;
};

const gameErrorRenderers: TGameErrorRenderers = {
  [GameErrorType.NotFound]: () => <GameErrorNotFound />,
  [GameErrorType.NotAvailCurrency]: ({ payload }) => (
    <GameErrorNotAvailCurrency availableCurrency={payload.availableCurrency} />
  ),
  [GameErrorType.GeoBlocked]: () => <GameErrorGeoBlocked />,
  [GameErrorType.NotAuth]: ({ payload }) => <GameErrorNotAuth {...payload} />,
};

interface IGameErrorContentProps<K extends GameErrorType> {
  error: Extract<GameErrorT, { type: K }>;
}

export const GameErrorContent = <K extends GameErrorType>({
  error,
}: IGameErrorContentProps<K>): ReactElement =>
  gameErrorRenderers[error.type](error);
